import {isNotNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Stores a scalar field as an override only when it differs from the template. A value equal to the
 * template becomes `null`, so the field keeps following the template.
 */
export function resolveScalarOverride<T>(value: T, templateValue: T | Nullish) {
  return isNotNil(templateValue) && value === templateValue ? null : value;
}
